module.exports = __webpack_public_path__ + "img/gPay-pdf.c802834e.svg";